import { useTranslation } from 'react-i18next';
import React, { useEffect } from "react";
import { Table, } from "antd";
import { useAllocModel } from "../inventoryStatisticsModel";
// import { useRecordGoodsModel } from '@/erp_subpackage/views/public/GoodsRecordsModal/recordGoodsModel';
import { formatNum } from '@/erp_subpackage/utils/util'
import { useGlobalModel } from "@/erp_subpackage/model/globalModel";

export function DataTable() {
    const { t } = useTranslation();
    const { setMaterialInfo } = useGlobalModel(() => []);
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys,
    } = useAllocModel();
    // const { setGoodsRecordModal } = useRecordGoodsModel(() => []);

    const detailColumns = [
        {
            title: t(`stock.view.DataTable.序号`),
            width: 60,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: t(`stock.view.DataTable.商品编号`),
            fixed: "left",
            width: 160,
            dataIndex: 'materialCode',
        },
        {
            title: t(`stock.view.DataTable.商品名称`),
            fixed: "left",
            width: 180,
            dataIndex: 'materialName',
        },
        {
            title: t(`stock.view.DataTable.仓库`),
            width: 160,
            dataIndex: 'warehouseName',
        }, {
            title: t(`stock.view.DataTable.货位`),
            width: 160,
            dataIndex: 'shelfCode',
        },
        {
            title: t(`stock.view.DataTable.库存数量`),
            width: 100,
            dataIndex: 'inventoryQuantity',
        },
        {
            title: t(`stock.view.DataTable.占用库存`),
            width: 100,
            dataIndex: 'occupyNum',
        },
        {
            title: t(`stock.view.DataTable.可用库存`),
            width: 100,
            dataIndex: 'num',
            render: (text, record) => +(record?.inventoryQuantity ?? 0) - +(record?.occupyNum ?? 0)
        },
        {
            title: t(`stock.view.DataTable.最新进价`),
            width: 100,
            dataIndex: 'lastPurchasePrice',
            render: text => `￥${formatNum(text)}`
        },
        {
            title: t(`stock.view.DataTable.库存成本`),
            width: 100,
            dataIndex: 'inventoryAmount',
            render: text => `￥${formatNum(text)}`
        },
        {
            title: t(`stock.view.DataTable.最初入库日期`),
            width: 200,
            dataIndex: 'lastStockIoTime',
        },
        {
            title: t(`stock.view.DataTable.是否存在积压`),
            width: 100,
            dataIndex: 'overstockFlag',
            render: (text) => text ? t(`stock.view.DataTable.是`) : t(`stock.view.DataTable.否`)
        },
        {
            title: t(`stock.view.DataTable.库龄`),
            width: 100,
            dataIndex: 'overstock',
        },
        {
            title: t(`stock.view.DataTable.最近一月是否销售`),
            width: 130,
            dataIndex: 'saleRecent',
            render: (text) => text ? t(`stock.view.DataTable.是`) : t(`stock.view.DataTable.否`)
        },
        {
            title: t(`stock.view.DataTable.最近一年是否销售`),
            width: 130,
            dataIndex: 'saleRecentYear',
            render: (text) => text ? t(`stock.view.DataTable.是`) : t(`stock.view.DataTable.否`)
        },
        {
            title: t(`stock.view.DataTable.年周转率`),
            width: 100,
            dataIndex: 'turnoverRate',
        },
        {
            title: t(`stock.view.DataTable.积压率`),
            width: 100,
            dataIndex: 'overstockRate',
        },
        {
            title: t(`stock.view.DataTable.销存率`),
            width: 100,
            dataIndex: 'saleOverstockRate',
        }
    ];
    useEffect(() => {
        loadData()
    }, [])

    //点击行选高亮
    const onRow = (id) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            loading={loading}
            rowKey={(record, i) => record.id || record.materialCode + i}
            // rowSelection={{
            //     //全部选中时  (存string[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         let changeRowId = changeRows.map(item => item.id);
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
            //             : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
            //     },
            //     onSelect: (record) => onRow(record.id),
            //     selectedRowKeys: selectedRowKeys
            // }}
            columns={detailColumns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `${t(`stock.view.DataTable.共`)}${pgCfg.total}${t(`stock.view.DataTable.条`)}`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 350px)" }}
        />
    )
}
